/* unplugin-vue-components disabled */import { render } from "./Featured.vue?vue&type=template&id=e3f614e2&scoped=true"
const script = {}

import "./Featured.vue?vue&type=style&index=0&id=e3f614e2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3f614e2"]])

export default __exports__